module.exports = __webpack_public_path__ + "src/images/products/trendsetter/105_Round Neck Striped Jumper.png";